"use client"

import { Images } from "@/constants/images";
import Image from "next/image";
import { useSearchParams } from "next/navigation";

interface SearchFormProps {
  placeholderText: string;
  locale: string;
}

function SearchFormView({
  placeholderText,
  locale,
  currentQuery,
}: SearchFormProps & { currentQuery: string }) {
  const formAction = `/${locale}/search`

  return (
    <form action={formAction} method="get" className="relative">
      <div className="relative bg-[#F5F5F5] h-[36px] rounded-[0.3125rem] flex items-center">
        <input
          type="text"
          name="q"
          placeholder={placeholderText}
          defaultValue={currentQuery}
          className="w-[180px] mx-3 pr-10 pb-[0.25px] placeholder:text-[#242F3E] placeholder:text-opacity-90 text-sm bg-transparent focus:outline-none"
          autoComplete="off"
        />
        <button
          type="submit"
          className="absolute right-2 top-1/2 -translate-y-1/2 pb-[2.5px] hover:opacity-70 transition-opacity"
          aria-label={placeholderText}
        >
          <Image
            src={Images.tamdaSearchIcon}
            alt={placeholderText}
            width={20}
            height={20}
            className="w-[1.1875rem] h-[1.1875rem]"
          />
        </button>
      </div>
    </form>
  )
}

export default function SearchForm({ placeholderText, locale }: SearchFormProps) {
  const searchParams = useSearchParams()
  const currentQuery = searchParams.get("q") || ""

  return <SearchFormView placeholderText={placeholderText} locale={locale} currentQuery={currentQuery} />
}

// Static twin used as the Suspense fallback. Renders the identical markup with an
// empty query so the swap is invisible (matches the no-`?q` case on every page
// except /search). Required because <SearchForm> calls useSearchParams(), which
// needs a Suspense boundary for static generation.
export function SearchFormFallback({ placeholderText, locale }: SearchFormProps) {
  return <SearchFormView placeholderText={placeholderText} locale={locale} currentQuery="" />
}
